/**
 * Quotes a watchlist keyword so a phrase is matched as a phrase.
 *
 * Newsquawk headlines search splits an unquoted term on whitespace and ORs the
 * words, so a watchlist keyword "rate cut" matches anything containing "rate"
 * OR "cut" — which is most of the wire on any day the Fed is mentioned.
 * Measured against production: `rate cut` returned generic daily news, while
 * `"rate cut"` returned the RBA minutes and overlapped the exact_match results
 * 17/17 against 3/27 for the loose form.
 *
 * Only multi-word keywords are touched. A single word cannot be split, so
 * quoting it would change nothing while risking whatever the backend does with
 * quotes around one token.
 *
 * Keywords already carrying a quote are left alone: they are either already a
 * phrase or something we would only mangle by nesting quotes inside quotes.
 */
export function quotePhrase(keyword: string): string {
  const trimmed = keyword.trim();
  if (!trimmed.includes(" ")) return trimmed;
  if (trimmed.includes('"')) return trimmed;
  return `"${trimmed}"`;
}

/** Applies `quotePhrase` across a list, dropping empties. */
export function quotePhrases(keywords: string[]): string[] {
  return keywords.map(quotePhrase).filter(Boolean);
}
